import {requestPost} from '@/utils/request';

const api = {
	MESSAGE_DETAIL: '/op/conversation_message_detail',
}

export async function conversationMessageDetail(queryParams) {
    return requestPost(api.MESSAGE_DETAIL, queryParams);
}
